import React, { useEffect, useState } from 'react'
import Slider from 'react-slick'
import { PrevArrow, NextArrow } from '../elements/CarouselArrows'
import formatLeadPromoDesc from '../../utils/formatLeadPromoDesc'
import moment from 'moment'

import '../../styles/scss/components/equote-package-related-sailings-slider.scss'
import TaxLine from '../TaxLine'

const renderTable = props => {
  return props.sailings.map((sailing, i) => {
    return (
      <div key={sailing.sailDate + i}>
        <div className="equote-package-related-sailings-slider--wrapper">
          <div className="equote-package-related-sailings-slider--row">
            <div className="equote-package-related-sailings-slider--row-head">
              Departure
            </div>
            <div className="equote-package-related-sailings-slider--row-body">
              {moment(sailing.sailDate, 'YYYY-MM-DD').format('MMMM DD, YYYY')}
            </div>
          </div>
          <div className="equote-package-related-sailings-slider--row">
            <div className="equote-package-related-sailings-slider--row-head">
              Nights
            </div>
            <div className="equote-package-related-sailings-slider--row-body">
              {sailing.sailingNights} Nights
            </div>
          </div>
          <div className="equote-package-related-sailings-slider--row">
            <div className="equote-package-related-sailings-slider--row-head">
              Destination
            </div>
            <div className="equote-package-related-sailings-slider--row-body">
              {sailing.destinationName}
            </div>
          </div>
          <div className="equote-package-related-sailings-slider--row">
            <div className="equote-package-related-sailings-slider--row-head">
              Ship
            </div>
            <div className="equote-package-related-sailings-slider--row-body">
              {sailing.shipName}
            </div>
          </div>
          <div className="equote-package-related-sailings-slider--row">
            <div className="equote-package-related-sailings-slider--row-head">
              PRICING
            </div>
            <div className="equote-package-related-sailings-slider--row-body" />
          </div>
          {props.availableStateRooms.map(stateRoom => {
            const stateRoomPricing = sailing.guestCountPricing[stateRoom.code]
            return (
              <div
                className="equote-package-related-sailings-slider--row"
                key={stateRoom.code + stateRoom.description}
              >
                <div className="equote-package-related-sailings-slider--row-head equote-package-related-sailings-slider--row-head--indent">
                  {stateRoom.description === 'Outside'
                    ? 'Ocean View'
                    : stateRoom.description}
                </div>
                <div className="equote-package-related-sailings-slider--row-body">
                  {stateRoomPricing && stateRoomPricing.bestGuestCountRate ? (
                    <>
                      <p
                        className="equote-package-related-sailings-slider--row-price"
                        style={{ whiteSpace: 'nowrap' }}
                      >
                        {sailing.currencySymbol || '$'}{' '}
                        {stateRoomPricing.bestGuestCountRate.netPrice.toFixed(
                          2
                        )}
                      </p>
                      <p className="equote-package-related-sailings-slider--row-promo">
                        {formatLeadPromoDesc(
                          stateRoomPricing.bestGuestCountRate.leadPromoDesc,
                          stateRoomPricing.bestGuestCountRate.promos
                        )}
                      </p>
                      <p className="equote-package-related-sailings-slider--row-promo">
                        {stateRoomPricing.bestGuestCountRate.isRefundable
                          ? `Regular Deposit`
                          : `Non-Refundable Deposit`}
                      </p>
                    </>
                  ) : (
                    <div className="equote-package-related-sailings-slider--row-sold-out">
                      <p>Sold Out</p>
                    </div>
                  )}
                </div>
              </div>
            )
          })}
          {sailing?.taxes && (
            <div>
              <i>
                <TaxLine
                  isBundlePricing={sailing.taxesFeesIncluded}
                  amount={sailing.taxes}
                  currency={sailing.currency}
                  currencySymbol={sailing.currencySymbol || '$'}
                  currencySymbolPlacement={
                    sailing.currencySymbolPlacement || 'start'
                  }
                />
              </i>
            </div>
          )}
        </div>
        <div className="equote-package-related-sailings-slider--row-buttons">
          <div
            onClick={() =>
              props.goToNextPage(sailing, props.requestAlternateSailing)
            }
            className="btn u-uppercase similar"
          >
            Request
          </div>
          <div className="btn u-uppercase btn-info">View Details</div>
        </div>
      </div>
    )
  })
}

const renderNumberOfSlidesToShow = () => {
  if (window.innerWidth > 1200) {
    return 3
  }
  if (window.innerWidth >= 768) {
    return 2
  }
  return 1
}

export default function EQuotePackageRelatedSailingsSlider(props) {
  const [numberOfSlidesToShow, setSlideCount] = useState(() =>
    renderNumberOfSlidesToShow()
  )

  const settings = {
    lazyLoad: 'progressive',
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: numberOfSlidesToShow,
    swipeToSlide: true,
    prevArrow: (
      <PrevArrow {...props} numberOfSlidesToShow={numberOfSlidesToShow} large />
    ),
    nextArrow: (
      <NextArrow {...props} numberOfSlidesToShow={numberOfSlidesToShow} large />
    )
  }

  useEffect(() => {
    const handleResize = () => {
      setSlideCount(() => renderNumberOfSlidesToShow())
    }
    window.addEventListener('resize', handleResize)
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])
  return (
    <div className="equote-package-related-sailings-slider">
      <Slider {...settings}>{renderTable(props)}</Slider>
      <p className="equote-package-related-sailings-slider--text">
        {props.disclaimer}
      </p>
    </div>
  )
}
